import React, {useEffect, useState, useRef} from 'react';
import FileUpload from "../../FileUploads/FileUpload";
import DropDownInput from "../../Input/dropDownInput/dropDownInput";
import SearchLocation from "../../searchLocation/searchLocation";
import Loader from "../../../Loader/Loader";

const CorporateBuilding = ({
                               documentUploadUrlPublic,
                               documentUrlDataPublic,
                               handleInput,
                               dropdownValue,
                               getCityStateByPincode,
                               pincodeData = [],
                               locationCity = [],
                               locationZone,
                               locationArea,
                               zones = [],
                               areas = [],
                               siteImages,
                               handleAddSiteImages,
                               removeSiteImages,
                               handleSiteImagesInput,
                               accountDetailsByIdData,
                               isEdit = false,
                               inputList,
                               setSiteImages,
                               isView=false
                           }) => {

    const [fmcName, setFmcName] = useState(0)
    const [existingInfra, setExistingInfra] = useState([{id: '', quantity: 0}])
    const [existingParking, setExistingParking] = useState({})
    const [isExistingOtherParking, setIsExistingOtherParking] = useState(false)
    const [isParkingSolutionExisting, setIsParkingSolutionExisting] = useState('')
    const [existingEvInfra, setExistingEvInfra] = useState('')
    const [leadSource, setLeadSource] = useState('');
    const [occupancyRateId, setOccupancyRateId] = useState(0)
    const [strategicPartnerId, setStrategicPartnerId] = useState(0)
    const [marqueeId, setMarqueeId] = useState(0)
    const [cityId, setCityId] = useState(0)
    const [zoneId, setZoneId] = useState(0)
    const [areaId, setAreaId] = useState(0)
    const [pincodeValue, setPincodeValue] = useState('')
    const [lat, setLat] = useState('')
    const [long, setLong] = useState('')
    const ref = useRef(null);
    const [click, setClick] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        getCityStateByPincode(pincodeValue)
    }, [pincodeValue])

    //
    useEffect(() => {
        if (click !== '' && !isView) {
            ref.current.click();
        }
    }, [click])

    const handleAddExistingInfra = () => {
        setExistingInfra(
            [
                ...existingInfra,
                {
                    id: '',
                    quantity: 0
                }
            ]
        )
    }

    const removeExistingInfra = (e, index) => {
        const list = [...existingInfra]
        list.splice(index, 1);
        setExistingInfra(list);
        e.preventDefault()
    }


    const handleExistingEvInfraInput = (index, key, val) => {
        let list = [...existingInfra];
        list[index][key] = val
        setExistingInfra(list)
    }

    useEffect(() => {
        handleInput(leadSource, 'lead_source_id')
    }, [leadSource])

    useEffect(() => {
        handleInput(fmcName, 'fmc_name_id')
    }, [fmcName])

    let values = []
    useEffect(() => {

        if (existingParking !== [] && existingParking !== '' && existingParking.length > 0) {
            existingParking.map((val, i) => {
                values[i] = val.id
                setIsExistingOtherParking(false)
                if (val.id === 5) {
                    setIsExistingOtherParking(true)
                }
            })
        }
        handleInput(values, 'existing_parking_solution_id')
    }, [existingParking])

    useEffect(() => {
        handleInput(existingInfra, 'existing_ev_infra')
    }, [existingInfra])

    useEffect(() => {
        handleInput(occupancyRateId, 'occupancy_id')
    }, [occupancyRateId])

    useEffect(() => {
        handleInput(strategicPartnerId, 'strategic_partner_id')
    }, [strategicPartnerId])

    useEffect(() => {
        handleInput(marqueeId, 'marquee_account')
    }, [marqueeId])

    useEffect(() => {
        (async () => {
            handleInput(cityId, 'city_id')
            await locationZone(cityId !== 0 ? cityId : accountDetailsByIdData?.city_id)
        })()
    }, [cityId, accountDetailsByIdData])

    useEffect(() => {
        (async () => {
            handleInput(zoneId, 'zone_id')
            await locationArea(zoneId !== 0 ? zoneId : accountDetailsByIdData?.zone_id)
        })()
    }, [zoneId, accountDetailsByIdData])

    useEffect(() => {
        handleInput(areaId, 'area_id')
    }, [areaId])

    useEffect(() => {
        handleInput(existingEvInfra, 'is_ev_infra_existing')
    }, [existingEvInfra])

    useEffect(() => {
        if (isParkingSolutionExisting === 'no') {
            setExistingParking({})
        }
        handleInput(isParkingSolutionExisting, 'is_existing_parking_solution')
    }, [isParkingSolutionExisting])

    const [optOption, setOptOption] = useState({
        address2: '',
        currentLocation: '',
    });
    const handleCurrentLocationBlur = (latlng = null) => {
        if (latlng !== null && latlng !== undefined) {
            setLong(latlng?.lng)
            setLat(latlng?.lat)
            handleInput(latlng?.lng, 'longitude')
            handleInput(latlng?.lat, 'latitude')
        }
    };

    const handleCurrentLocationChange = (value) => {
        setOptOption({...optOption, currentLocation: value});
        handleInput(value, 'current_location')
        if(!isEdit){
            handleInput(value, 'address_1')
        }
    };

    const [isInputError, setIsInputError] = useState({
        latError: false,
        longError: false,
        pinError: false,
        crl: false,
        isPinNotFound: false,
    });

    useEffect(() => {
        if (accountDetailsByIdData !== [] && accountDetailsByIdData?.account_type_id !== undefined) {
            if (accountDetailsByIdData?.is_existing_parking_solution !== undefined &&
                accountDetailsByIdData?.is_existing_parking_solution !== null &&
                accountDetailsByIdData?.is_existing_parking_solution !== '') {
                setIsParkingSolutionExisting(accountDetailsByIdData?.is_existing_parking_solution)
            }

            if (accountDetailsByIdData?.current_location !== undefined &&
                accountDetailsByIdData?.current_location !== null &&
                accountDetailsByIdData?.current_location !== '') {
                setOptOption({...optOption, currentLocation: accountDetailsByIdData?.current_location});
            }

            if (accountDetailsByIdData?.latitude !== undefined &&
                accountDetailsByIdData?.latitude !== null &&
                accountDetailsByIdData?.latitude !== '') {
                setLat(accountDetailsByIdData?.latitude)
            }

            if (accountDetailsByIdData?.longitude !== undefined &&
                accountDetailsByIdData?.longitude !== null &&
                accountDetailsByIdData?.longitude !== '') {
                setLong(accountDetailsByIdData?.longitude)
            }

            if (accountDetailsByIdData?.existing_ev_infra !== undefined &&
                accountDetailsByIdData?.existing_ev_infra !== null &&
                accountDetailsByIdData?.existing_ev_infra !== '') {
                setExistingInfra(accountDetailsByIdData?.existing_ev_infra)
            }

            if (accountDetailsByIdData?.is_ev_infra_existing !== undefined &&
                accountDetailsByIdData?.is_ev_infra_existing !== null &&
                accountDetailsByIdData?.is_ev_infra_existing !== '') {
                setExistingEvInfra(accountDetailsByIdData?.is_ev_infra_existing)
            }

            if (accountDetailsByIdData?.existing_parking_solution_other !== undefined &&
                accountDetailsByIdData?.existing_parking_solution_other !== null &&
                accountDetailsByIdData?.existing_parking_solution_other !== '') {
                setIsExistingOtherParking(accountDetailsByIdData?.existing_parking_solution_other)
            }

            handleInput(accountDetailsByIdData?.client_name, 'client_name')
            handleInput(accountDetailsByIdData?.lead_source_id, 'lead_source_id')
            handleInput(accountDetailsByIdData?.building_name, 'building_name')
            handleInput(accountDetailsByIdData?.developer_name, 'developer_name')
            handleInput(accountDetailsByIdData?.sale_team_name, 'sale_team_name')
            handleInput(accountDetailsByIdData?.name_of_referrer, 'name_of_referrer')
            handleInput(accountDetailsByIdData?.first_contact_date, 'first_contact_date')
            handleInput(accountDetailsByIdData?.fmc_name_id, 'fmc_name_id')
            handleInput(accountDetailsByIdData?.city_id, 'city_id')
            handleInput(accountDetailsByIdData?.zone_id, 'zone_id')
            handleInput(accountDetailsByIdData?.area_id, 'area_id')
            handleInput(accountDetailsByIdData?.address_1, 'address_1')
            handleInput(accountDetailsByIdData?.address_2, 'address_2')
            handleInput(accountDetailsByIdData?.pincode, 'pincode')
            setPincodeValue(accountDetailsByIdData?.pincode)
            handleInput(pincodeData?.geographical_city_id, 'geographical_city_id')
            handleInput(pincodeData?.geographical_state_id, 'geographical_state_id')
            handleInput(accountDetailsByIdData?.latitude, 'latitude')
            handleInput(accountDetailsByIdData?.longitude, 'longitude')
            handleInput(accountDetailsByIdData?.occupancy_id, 'occupancy_id')
            handleInput(accountDetailsByIdData?.strategic_partner_id, 'strategic_partner_id')
            handleInput(accountDetailsByIdData?.marquee_account, 'marquee_account')
            handleInput(accountDetailsByIdData?.is_existing_parking_solution, 'is_existing_parking_solution')
            handleInput(accountDetailsByIdData?.existing_parking_solution_ids, 'existing_parking_solution_id')
            handleInput(accountDetailsByIdData?.existing_parking_solution_name, 'existing_parking_solution_name')
            handleInput(accountDetailsByIdData?.existing_parking_solution_vendor_name, 'existing_parking_solution_vendor_name')
            handleInput(accountDetailsByIdData?.total_parking_slot, 'total_parking_slot')
            handleInput(accountDetailsByIdData?.gates, 'gates')
            handleInput(accountDetailsByIdData?.electric_vehicles, 'electric_vehicles')
            handleInput(accountDetailsByIdData?.is_ev_infra_existing, 'is_ev_infra_existing')
            handleInput(accountDetailsByIdData?.existing_ev_infra, 'existing_ev_infra')
            handleInput(accountDetailsByIdData?.existing_ev_solution_vendor_name, 'existing_ev_solution_vendor_name')
            handleInput(accountDetailsByIdData?.site_images, 'site_image')
        }

    }, [accountDetailsByIdData])

    useEffect(() => {
        if(accountDetailsByIdData?.site_images !== undefined){
            const tempArray = JSON.parse(JSON.stringify(accountDetailsByIdData?.site_images)) ?? []; // deep copy
            let len = tempArray.length
            for (let i = 0; i < len; i++) {
                setClick(i)
            }
        }
    }, [accountDetailsByIdData?.site_images])

    useEffect(() => {
        if(accountDetailsByIdData?.site_images !== undefined){
            const tempArray = JSON.parse(JSON.stringify(accountDetailsByIdData?.site_images)) ?? []; // deep copy
            let len = tempArray.length
            delete siteImages[0]['url']
            for (let i = 0; i < len; i++) {
                if (i === 0) {
                    siteImages[0]['url'] = tempArray[i]['url']
                } else {
                    siteImages.push({url: tempArray[i]['url']})
                }
            }

            setSiteImages(tempArray)
        }
    }, [accountDetailsByIdData?.site_images, click])

    return (
        <>
            <Loader isLoading={isLoading}/>
            <div className="col-md-12">
                <div
                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                    <h1 className="h3 mb-0 text-black-100">Account Details</h1>
                </div>
                <div className="card-body bg-white">
                    <div className="user">
                        <div className="form-group row">
                            <div className="col-md-6 float-field ">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput(e.target.value, 'client_name')
                                       }}
                                       required
                                       value={inputList[0]?.client_name}
                                       disabled={isView}
                                />

                                <label className="large-label float-lb">
                                    Client Name <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            {isView && inputList[0]?.building_name !== '' &&
                                <div className="col-md-6 float-field">
                                    <input type="text"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'building_name')
                                           }}
                                           value={inputList[0]?.building_name}
                                           required
                                           disabled={isView}
                                    />
                                    <label className="large-label float-lb">
                                        Account Name/Building Name <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            }

                            {!isView &&
                                <div className="col-md-6 float-field">
                                    <input type="text"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'building_name')
                                           }}
                                           value={inputList[0]?.building_name}
                                           required
                                    />
                                    <label className="large-label float-lb">
                                        Account Name/Building Name <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            }
                            <div className="col-md-6 float-field">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput(e.target.value, 'developer_name')
                                       }}
                                       value={inputList[0]?.developer_name}
                                       disabled={isView}
                                />
                                <label className="large-label float-lb">
                                    Developer Name
                                </label>
                            </div>

                            {isView &&
                                <div className="col-md-6 float-field mt-sel">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setLeadSource(e.target.value)
                                    }} required disabled={true} style={{backgroundImage:"none"}}>
                                        <option value="">Select Account Source</option>
                                        {dropdownValue?.corporate_lead_source!== undefined && dropdownValue?.corporate_lead_source.map((val) => {
                                            return (
                                                <>
                                                    {(accountDetailsByIdData?.lead_source_id === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb">
                                        Account Source <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-md-6 float-field mt-sel">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setLeadSource(e.target.value)
                                    }} required >
                                        <option value="">Select Account Source</option>
                                        {dropdownValue?.corporate_lead_source!== undefined && dropdownValue?.corporate_lead_source.map((val) => {
                                            return (
                                                <>
                                                    {(accountDetailsByIdData?.lead_source_id === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb">
                                        Account Source <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            }

                            {(parseInt(accountDetailsByIdData?.lead_source_id) === 24 || parseInt(leadSource) ===24) &&
                                <div className="col-md-6 float-field mt-sel">
                                <select className="form-control form-control-user" onChange={(e) => {
                                    handleInput(e.target.value, 'sale_team_name')
                                }} required >
                                    <option value="">Source of acquisition</option>
                                    {accountDetailsByIdData?.sale_team_name === "Indiamart" ?
                                        <>
                                            <option value="Indiamart" selected>Indiamart</option>
                                            <option value="Just Dial">Just Dial</option>
                                            <option value=" Park+ online leads "> Park+ online leads</option>
                                            <option value="Referral">Referral</option>
                                        </>
                                        : accountDetailsByIdData?.sale_team_name === "Just Dial" ?
                                            <>
                                                <option value="Indiamart">Indiamart</option>
                                                <option value="Just Dial" selected>Just Dial</option>
                                                <option value=" Park+ online leads "> Park+ online leads</option>
                                                <option value="Referral">Referral</option>
                                            </> :
                                            accountDetailsByIdData?.sale_team_name === "Park+ online leads" ?
                                                <>
                                                    <option value="Indiamart">Indiamart</option>
                                                    <option value="Just Dial">Just Dial</option>
                                                    <option value="Park+ online leads" selected> Park+ online leads
                                                    </option>
                                                    <option value="Referral">Referral</option>
                                                </> :
                                                accountDetailsByIdData?.sale_team_name === "Referral" ?
                                                    <>
                                                        <option value="Indiamart">Indiamart</option>
                                                        <option value="Just Dial">Just Dial</option>
                                                        <option value="Park+ online leads"> Park+ online
                                                            leads
                                                        </option>
                                                        <option value="Referral" selected>Referral</option>
                                                    </>
                                                    :
                                                    <>
                                                        <option value="Indiamart">Indiamart</option>
                                                        <option value="Just Dial">Just Dial</option>
                                                        <option value="Park+ online leads"> Park+ online leads</option>
                                                        <option value="Referral">Referral</option>
                                                    </>
                                    }

                                </select>
                                    <label className="large-label float-lb">
                                        Source of acquisition <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            }
                            {(parseInt(accountDetailsByIdData?.lead_source_id) === 19 || parseInt(leadSource) === 19) &&
                                <div className="col-md-6 float-field mtk-025">
                                    <input type="text"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'name_of_referrer')
                                           }}
                                           value={accountDetailsByIdData?.name_of_referrer}
                                           required
                                           disabled={isView}
                                    />

                                    <label className="large-label float-lb">
                                        Name Of Referrer <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            }
                            <div className="col-md-6 float-field mt-sel">
                                <input type="date"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput(e.target.value, 'first_contact_date')
                                       }}
                                       value={inputList[0]?.first_contact_date}
                                       required
                                       disabled={isView}
                                />
                                <label className="large-label float-lb">
                                    First Contact Date <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>


                            {isView && accountDetailsByIdData?.fmc_name_id!=='' && accountDetailsByIdData?.fmc_name_id!== null &&
                                <div className="col-md-6 float-field">
                                    <select className="form-control form-control-user"
                                            onChange={(e) => setFmcName(e.target.value)} disabled={isView} style={{backgroundImage:"none"}}>
                                        <option value="">Select FMC Name</option>
                                        {dropdownValue?.corporate_fmc_name!== undefined && dropdownValue?.corporate_fmc_name.map((val) => {
                                            return (
                                                <>
                                                    {(parseInt(accountDetailsByIdData?.fmc_name_id) === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>

                                    <label className="large-label float-lb">
                                        FMC Name
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-md-6 float-field">
                                    <select className="form-control form-control-user"
                                            onChange={(e) => setFmcName(e.target.value)} disabled={isView}>
                                        <option value="">Select FMC Name</option>
                                        {dropdownValue?.corporate_fmc_name!== undefined && dropdownValue?.corporate_fmc_name.map((val) => {
                                            return (
                                                <>
                                                    {(parseInt(accountDetailsByIdData?.fmc_name_id) === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>

                                    <label className="large-label float-lb">
                                        FMC Name
                                    </label>
                                </div>
                            }
                            {(parseInt(accountDetailsByIdData?.fmc_name_id) === 8 || parseInt(fmcName) === 8) &&
                                <div className="col-md-6 float-field">
                                    <input type="text"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'fmc_name')
                                           }}
                                           value={inputList[0]?.fmc_name}
                                           required
                                           disabled={isView}
                                    />

                                    <label className="large-label float-lb">
                                        Fmc Name <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-12">
                <div
                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                    <h1 className="h3 mb-0 text-black-100">Location</h1>
                </div>
                <div className="card-body  bg-white">
                    <div className="user">
                        <div className="form-group row">
                            {/*<div className="col-md-6 float-field">*/}
                            {/*    <input type="text"*/}
                            {/*           className="form-control form-control-user"*/}
                            {/*           placeholder=" "*/}
                            {/*           onChange={(e) => {*/}
                            {/*               handleInput(e.target.value, 'address_2')*/}
                            {/*           }}*/}
                            {/*           value={inputList[0]?.address_2}*/}
                            {/*    />*/}

                            {/*    <label className="large-label float-lb">*/}
                            {/*        Address of site 2*/}
                            {/*    </label>*/}
                            {/*</div>*/}
                            <SearchLocation
                                handleCurrentLocationBlur={handleCurrentLocationBlur}
                                isError={isInputError.crl}
                                value={optOption.currentLocation}
                                handleCurrentLocationChange={handleCurrentLocationChange}
                                isView={isView}
                                setPincodeValue={setPincodeValue}
                            />
                            <div className="col-md-6 float-field">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(val) => {
                                           handleInput(val, 'latitude')
                                       }}
                                       value={lat}
                                       disabled={isView}
                                />

                                <label className="large-label float-lb">
                                    Latitude <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-md-6 float-field">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(val) => {
                                           handleInput(val, 'longitude')
                                       }}
                                       value={long}
                                       disabled={isView}
                                />

                                <label className="large-label float-lb">
                                    Longitude <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-md-6 float-field d-mtk-1">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput(e.target.value, 'address_1')
                                       }}
                                       required
                                       value={inputList[0].address_1}
                                       disabled={isView}
                                />

                                <label className="large-label float-lb">
                                    Address of site 1 <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-md-6 float-field">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           setPincodeValue(e.target.value, 'pincode')
                                       }}
                                       value={pincodeValue}
                                       required
                                       disabled={isView}
                                />

                                <label className="large-label float-lb">
                                    Pincode <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-md-6 float-field">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput(pincodeData?.geo_city_id, 'geographical_city_id')
                                       }}
                                       disabled
                                       value={pincodeData?.city_name !== undefined ? pincodeData?.city_name : ''}
                                       required
                                />

                                <label className="large-label float-lb">
                                    Geographical City <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-md-6 float-field">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput(pincodeData?.geo_state_id, 'geographical_state_id')
                                       }}
                                       disabled
                                       value={pincodeData?.state_name !== undefined ? pincodeData?.state_name : ''}
                                       required
                                />

                                <label className="large-label float-lb">
                                    Geographical State <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-md-6 float-field mt-1">
                                <select className="form-control form-control-user"
                                        onChange={(e) => setCityId(e.target.value)} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                    <option value="">Select City</option>
                                    {locationCity.map((val) => {
                                        return (
                                            <>
                                                {(parseInt(accountDetailsByIdData?.city_id) === val?.id) ?
                                                    <>
                                                        return (
                                                        <option value={val?.id} selected>{val.name}</option>
                                                        )
                                                    </> :
                                                    <option value={val?.id}>{val.name}</option>
                                                }
                                            </>
                                        )
                                    })}
                                    required
                                </select>

                                <label className="large-label float-lb">
                                    City <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-md-6 float-field mtk-1 d-mtk-033">
                                <select className="form-control form-control-user"
                                        onChange={(e) => setZoneId(e.target.value)} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                    <option value="">Select Zone</option>
                                    {zones.map((val) => {
                                        return (
                                            <>
                                                {(parseInt(accountDetailsByIdData?.zone_id) === val?.id) ?
                                                    <>
                                                        return (
                                                        <option value={val?.id} selected>{val.name}</option>
                                                        )
                                                    </> :
                                                    <option value={val?.id}>{val.name}</option>
                                                }
                                            </>
                                        )
                                    })}
                                    required
                                </select>

                                <label className="large-label float-lb">
                                    Zone <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                            <div className="col-md-6 float-field mtk-2 d-mtk-1">
                                <select className="form-control form-control-user"
                                        onChange={(e) => setAreaId(e.target.value)} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                    <option value="">Select Area/Sector</option>
                                    {areas.map((val) => {
                                        return (
                                            <>
                                                {(parseInt(accountDetailsByIdData?.area_id) === val?.id) ?
                                                    <>
                                                        return (
                                                        <option value={val?.id} selected>{val.name}</option>
                                                        )
                                                    </> :
                                                    <option value={val?.id}>{val.name}</option>
                                                }
                                            </>
                                        )
                                    })}
                                    required
                                </select>

                                <label className="large-label float-lb">
                                    Area/Sector <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-12">
                <div
                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                    <h1 className="h3 mb-0 text-black-100">Others Details</h1>
                </div>
                <div className="card-body  bg-white">
                    <div className="user">
                        <div className="form-group row">
                            {isView && accountDetailsByIdData?.occupancy_id !== '' && accountDetailsByIdData?.occupancy_id !== null &&
                                <div className="col-md-6 float-field">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setOccupancyRateId(e.target.value)
                                    }} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                        <option value="">Select Occupancy rate</option>
                                        {dropdownValue?.occupancy!== undefined && dropdownValue?.occupancy.map((val) => {
                                            return (
                                                <>
                                                    {(parseInt(accountDetailsByIdData?.occupancy_id) === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb">
                                        Occupancy rate
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-md-6 float-field">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setOccupancyRateId(e.target.value)
                                    }}>
                                        <option value="">Select Occupancy rate</option>
                                        {dropdownValue?.occupancy!== undefined && dropdownValue?.occupancy.map((val) => {
                                            return (
                                                <>
                                                    {(parseInt(accountDetailsByIdData?.occupancy_id) === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>
                                    <label className="large-label float-lb">
                                        Occupancy rate
                                    </label>
                                </div>
                            }
                            {isView && accountDetailsByIdData?.strategic_partner_id !== '' && accountDetailsByIdData?.strategic_partner_id !== null &&
                                <div className="col-md-6 float-field mtk-075">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setStrategicPartnerId(e.target.value)
                                    }} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                        <option value="">Select Strategic Partner</option>
                                        {dropdownValue?.strategic_partner!== undefined && dropdownValue?.strategic_partner.map((val) => {
                                            return (
                                                <>
                                                    {(parseInt(accountDetailsByIdData?.strategic_partner_id) === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>

                                    <label className="large-label float-lb">
                                        Strategic Partner
                                    </label>
                                </div>
                            }

                            {!isView &&
                                <div className="col-md-6 float-field mtk-075">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setStrategicPartnerId(e.target.value)
                                    }}>
                                        <option value="">Select Strategic Partner</option>
                                        {dropdownValue?.strategic_partner!== undefined && dropdownValue?.strategic_partner.map((val) => {
                                            return (
                                                <>
                                                    {(parseInt(accountDetailsByIdData?.strategic_partner_id) === val?.id) ?
                                                        <>
                                                            return (
                                                            <option value={val?.id} selected>{val.name}</option>
                                                            )
                                                        </> :
                                                        <option value={val?.id}>{val.name}</option>
                                                    }
                                                </>
                                            )
                                        })}
                                    </select>

                                    <label className="large-label float-lb">
                                        Strategic Partner
                                    </label>
                                </div>
                            }
                            {isView && accountDetailsByIdData?.marquee_account !== '' && accountDetailsByIdData?.marquee_account !== null &&
                                <div className="col-md-6 float-field mtk-075 d-mtk-2">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setMarqueeId(e.target.value)
                                    }} disabled={isView} style={isView ? {backgroundImage:"none"} : ""}>
                                        <option value="">Select Marquee Account</option>
                                        {accountDetailsByIdData?.marquee_account === 'yes' ?
                                            <>
                                                <option value="yes" selected>Yes</option>
                                                <option value="no">No</option>
                                            </> :
                                            accountDetailsByIdData?.marquee_account === 'no' ?
                                                <>
                                                    <option value="yes">Yes</option>
                                                    <option value="no" selected>No</option>
                                                </> :
                                                <>
                                                    <option value="yes">Yes</option>
                                                    <option value="no">No</option>
                                                </>
                                        }

                                    </select>
                                    <label className="large-label float-lb">
                                        Marquee Account
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-md-6 float-field mtk-075 d-mtk-2">
                                    <select className="form-control form-control-user" onChange={(e) => {
                                        setMarqueeId(e.target.value)
                                    }}>
                                        <option value="">Select Marquee Account</option>
                                        {accountDetailsByIdData?.marquee_account === 'yes' ?
                                            <>
                                                <option value="yes" selected>Yes</option>
                                                <option value="no">No</option>
                                            </> :
                                            accountDetailsByIdData?.marquee_account === 'no' ?
                                                <>
                                                    <option value="yes">Yes</option>
                                                    <option value="no" selected>No</option>
                                                </> :
                                                <>
                                                    <option value="yes">Yes</option>
                                                    <option value="no">No</option>
                                                </>
                                        }

                                    </select>
                                    <label className="large-label float-lb">
                                        Marquee Account
                                    </label>
                                </div>
                            }
                            {isView && accountDetailsByIdData?.is_existing_parking_solution !== '' && accountDetailsByIdData?.is_existing_parking_solution !== null &&
                                <div className="col-md-6 float-field mtk-075 d-mtk-2">
                                    <select className="form-control form-control-user"
                                            onChange={(e) => setIsParkingSolutionExisting(e.target.value)} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                        <option value="">Select Is Existing Parking Solution</option>
                                        {accountDetailsByIdData?.is_existing_parking_solution === 'yes' ?
                                            <>
                                                <option value="yes" selected>Yes</option>
                                                <option value="no">No</option>
                                            </> : accountDetailsByIdData?.is_existing_parking_solution === 'no' ?
                                                <>
                                                    <option value="yes">Yes</option>
                                                    <option value="no" selected>No</option>
                                                </> :
                                                <>
                                                    <option value="yes">Yes</option>
                                                    <option value="no">No</option>
                                                </>
                                        }
                                    </select>
                                    <label className="large-label float-lb">
                                        Is Existing Parking Solution
                                    </label>
                                </div>
                            }

                            {!isView &&
                                <div className="col-md-6 float-field mtk-075 d-mtk-2">
                                    <select className="form-control form-control-user"
                                            onChange={(e) => setIsParkingSolutionExisting(e.target.value)} >
                                        <option value="">Select Is Existing Parking Solution</option>
                                        {accountDetailsByIdData?.is_existing_parking_solution === 'yes' ?
                                            <>
                                                <option value="yes" selected>Yes</option>
                                                <option value="no">No</option>
                                            </> : accountDetailsByIdData?.is_existing_parking_solution === 'no' ?
                                                <>
                                                    <option value="yes">Yes</option>
                                                    <option value="no" selected>No</option>
                                                </> :
                                                <>
                                                    <option value="yes">Yes</option>
                                                    <option value="no">No</option>
                                                </>
                                        }
                                    </select>
                                    <label className="large-label float-lb">
                                        Is Existing Parking Solution
                                    </label>
                                </div>
                            }
                            {(isParkingSolutionExisting === 'yes') &&
                                <div className="col-md-6 float-field mtk-075 d-mtk-2">
                                    <DropDownInput
                                        data={dropdownValue?.existing_parking_solution}
                                        label={'Existing Parking Solution'}
                                        isStarRequired={true}
                                        getIdValue={(val) => {
                                            setExistingParking(val)
                                        }}
                                        multipule={true}
                                        selectedList={accountDetailsByIdData?.existing_parking_solution_names}
                                        disabled={isView}
                                    />
                                </div>
                            }

                            {(isExistingOtherParking && isParkingSolutionExisting) === 'yes' &&
                                <div className="col-md-6 float-field mt-3">
                                    <input type="text"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'existing_parking_solution_name')
                                           }}
                                           required
                                           value={inputList[0]?.existing_parking_solution_name}
                                           disabled={isView}
                                    />

                                    <label className="large-label float-lb">
                                        Existing Parking Solution Name <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            }

                            {isParkingSolutionExisting === 'no' &&
                                <div className="col-md-6 float-field mt-3  d-mtk-2">
                                    <input type="text"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'existing_parking_solution_vendor_name')
                                           }}
                                           required
                                           value={inputList[0]?.existing_parking_solution_vendor_name}
                                           disabled={isView}
                                    />

                                    <label className="large-label float-lb">
                                        Vendor Name <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            }

                            {isView && accountDetailsByIdData?.total_parking_slot !== '' && accountDetailsByIdData?.total_parking_slot !== null &&
                                <div className="col-md-6 float-field mtk-075">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'total_parking_slot')
                                           }}
                                           value={inputList[0]?.total_parking_slot}
                                           disabled={isView}
                                    />

                                    <label className="large-label float-lb">
                                        Parking Slots
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-md-6 float-field mtk-05 d-mtk-2">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'total_parking_slot')
                                           }}
                                           value={inputList[0]?.total_parking_slot}
                                           disabled={isView}
                                    />

                                    <label className="large-label float-lb">
                                        Parking Slots
                                    </label>
                                </div>
                            }
                            {isView && accountDetailsByIdData?.gates !== '' && accountDetailsByIdData?.gates !== null &&
                                <div className="col-md-6 float-field d-mtk-2">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'gates')
                                           }}
                                           value={inputList[0]?.gates}
                                           disabled={isView}
                                    />

                                    <label className="large-label float-lb">
                                        Gates
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-md-6 float-field d-mtk-2">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'gates')
                                           }}
                                           value={inputList[0]?.gates}
                                           disabled={isView}
                                    />

                                    <label className="large-label float-lb">
                                        Gates
                                    </label>
                                </div>
                            }
                            {isView && accountDetailsByIdData?.electric_vehicles !== '' && accountDetailsByIdData?.electric_vehicles !== null &&
                                <div className="col-md-6 float-field d-mtk-1">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'electric_vehicles')
                                           }}
                                           value={inputList[0]?.electric_vehicles}
                                           disabled={isView}
                                    />

                                    <label className="large-label float-lb">
                                        Electric Vehichles
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-md-6 float-field d-mtk-1">
                                    <input type="number"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'electric_vehicles')
                                           }}
                                           value={inputList[0]?.electric_vehicles}
                                           disabled={isView}
                                    />

                                    <label className="large-label float-lb">
                                        Electric Vehichles
                                    </label>
                                </div>
                            }
                            {isView && accountDetailsByIdData?.is_ev_infra_existing !== '' && accountDetailsByIdData?.is_ev_infra_existing !== null &&
                                <div className="col-md-6 float-field mt-1 d-mtk-1">
                                    <select className="form-control form-control-user"
                                            onChange={(e) => setExistingEvInfra(e.target.value)} disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                        <option value="">Is Existing EV Infrastructure</option>
                                        {accountDetailsByIdData?.is_ev_infra_existing === 'yes' ?
                                            <>
                                                <option value="yes" selected>Yes</option>
                                                <option value="no">No</option>
                                            </> : accountDetailsByIdData?.is_ev_infra_existing === 'no' ?
                                                <>
                                                    <option value="yes">Yes</option>
                                                    <option value="no" selected>No</option>
                                                </> :
                                                <>
                                                    <option value="yes">Yes</option>
                                                    <option value="no">No</option>
                                                </>
                                        }
                                    </select>

                                    <label className="large-label float-lb">
                                        Existing EV Infrastructure
                                    </label>
                                </div>
                            }
                            {!isView &&
                                <div className="col-md-6 float-field mt-1 d-mtk-1">
                                    <select className="form-control form-control-user"
                                            onChange={(e) => setExistingEvInfra(e.target.value)} >
                                        <option value="">Is Existing EV Infrastructure</option>
                                        {accountDetailsByIdData?.is_ev_infra_existing === 'yes' ?
                                            <>
                                                <option value="yes" selected>Yes</option>
                                                <option value="no">No</option>
                                            </> : accountDetailsByIdData?.is_ev_infra_existing === 'no' ?
                                                <>
                                                    <option value="yes">Yes</option>
                                                    <option value="no" selected>No</option>
                                                </> :
                                                <>
                                                    <option value="yes">Yes</option>
                                                    <option value="no">No</option>
                                                </>
                                        }
                                    </select>

                                    <label className="large-label float-lb">
                                        Existing EV Infrastructure
                                    </label>
                                </div>
                            }
                            {existingEvInfra === 'yes' &&
                                existingInfra.map((v, i) => {
                                    return (
                                        <>
                                            <div className="col-md-6 float-field mtk-075">
                                                <select className="form-control form-control-user" onChange={(e) => {
                                                    handleExistingEvInfraInput(i, 'id', e.target.value)
                                                }} required disabled={isView} style={isView ? {backgroundImage:"none"} : {}}>
                                                    <option>Select Existing EV Infrastructure</option>
                                                    {dropdownValue?.existing_ev_infrastructure!== undefined && dropdownValue?.existing_ev_infrastructure.map((val) => {
                                                        return (
                                                            <>
                                                                {(parseInt(v?.id) === val?.id) ?
                                                                    <>
                                                                        return (
                                                                        <option value={val?.id}
                                                                                selected>{val.name}</option>
                                                                        )
                                                                    </> :
                                                                    <option value={val?.id}>{val.name}</option>
                                                                }
                                                            </>
                                                        )
                                                    })}
                                                </select>
                                                <label className="large-label float-lb">
                                                    Existing EV Infrastructure <i
                                                    className="bi bi-asterisk astrick-icon"></i>
                                                </label>
                                            </div>
                                            <div className="col-md-6 float-field mtk-025 d-mtk-1">
                                                <input type="number"
                                                       className="form-control form-control-user"
                                                       placeholder=" "
                                                       onChange={(e) => {
                                                           handleExistingEvInfraInput(i, 'quantity', e.target.value)
                                                       }}
                                                       required
                                                       value={parseInt(v?.quantity)}
                                                       disabled={isView}
                                                />

                                                <label className="large-label float-lb">
                                                    Quantity <i className="bi bi-asterisk astrick-icon"></i>
                                                </label>
                                            </div>
                                            {!isView &&
                                                <div className="btn-box mb-4"
                                                     style={{"width": "100%"}}>
                                                    {existingInfra.length !== 1 &&
                                                        <>
                                                            <button
                                                                onClick={(e) => removeExistingInfra(e, i)}
                                                                className="btn btn-sm btn-danger ml-3">Remove
                                                            </button>
                                                        </>
                                                    }
                                                    {existingInfra.length - 1 === i &&
                                                        <button
                                                            className="btn btn-sm btn-primary ml-3 btn-ar"
                                                            onClick={() => handleAddExistingInfra()}>Add
                                                        </button>}
                                                </div>
                                            }
                                        </>
                                    )
                                })
                            }

                            {existingEvInfra === 'no' &&
                                <div className="col-md-6 float-field mt-1">
                                    <input type="text"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput(e.target.value, 'existing_ev_solution_vendor_name')
                                           }}
                                           required
                                           value={inputList[0]?.existing_ev_solution_vendor_name}
                                           disabled={isView}
                                    />

                                    <label className="large-label float-lb">
                                        Vendor Name <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            }
                            <br/>
                            {siteImages && siteImages.map((val, i) => {
                                return (
                                    <>
                                        {!isView &&
                                            <div className="col-sm-6 mt-2 d-mtk-01">
                                                <FileUpload
                                                    id={"addAttachment" + i + 1}
                                                    accept=".png,.jpg,.jpeg"
                                                    documentUploadUrl={documentUploadUrlPublic}
                                                    documentUrlData={documentUrlDataPublic}
                                                    onChange={(val) => {
                                                        handleSiteImagesInput(i, val)
                                                    }}
                                                    prefilledFilename={val?.url !== '' && val?.url !== null ? "Uploaded Image" : ''}
                                                    isView={isView}
                                                >
                                                    Site Image
                                                </FileUpload>
                                            </div>
                                        }

                                        <div className="col-sm-6 mt-2">
                                            <img src={val?.url}/>
                                        </div>
                                        {!isView &&
                                            <div className="btn-box mb-4">
                                                {siteImages.length !== 1 &&
                                                    <>
                                                        <button
                                                            onClick={(e) => removeSiteImages(e, i)}
                                                            className="btn btn-sm btn-danger ml-3 btn-ar">Remove
                                                        </button>
                                                    </>
                                                }
                                                {siteImages.length - 1 === i &&
                                                    <button type="button"
                                                            className="btn btn-sm btn-primary ml-3 btn-ar" ref={ref}
                                                            onClick={() => handleAddSiteImages()}>Add More
                                                    </button>}
                                            </div>
                                        }
                                    </>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CorporateBuilding;